import classNames from 'classnames';
import { CredentialResponse } from 'google-one-tap';
import React, { createRef, useEffect } from 'react';

import { IdentityProviderTypes } from 'common/constants/IdentityProvidersTypes';
import loadGoogleClient, {
  getGoogleCredentialResponse
} from 'common/third_party/google';

import { CredentialsToSubmit } from './SocialSignButtons';
import styles from './styles.module.scss';

type GoogleButtonProps = {
  onSocialClick: (credentials: CredentialsToSubmit) => void;
};

const GoogleButton = ({ onSocialClick }: GoogleButtonProps) => {
  const buttonGoogleRef = createRef<HTMLDivElement>();

  const handleGoogleConnect = (response: CredentialResponse) => {
    onSocialClick({
      ...getGoogleCredentialResponse(response),
      provider: IdentityProviderTypes.GOOGLE
    });
  };

  // Since the Google OAuth 2.0 version, the login can
  // no longer be done on the click action by the user.
  // You have to load the Google api to inject the login
  // button. (It is no longer possible to load Google
  // scripts lazily).
  //
  // https://developers.google.com/identity/gsi/web/reference/js-reference?hl=fr
  //
  useEffect(() => {
    const googleButton = buttonGoogleRef.current;
    if (googleButton) {
      loadGoogleClient(() => {
        window?.google?.accounts?.id?.renderButton?.(googleButton, {
          type: 'icon',
          size: 'large'
        });
      }, handleGoogleConnect);
    }
  }, [buttonGoogleRef]);

  return (
    <div
      className={classNames('button-sign-social', styles.googleButton)}
      ref={buttonGoogleRef}
    />
  );
};

export default GoogleButton;
